// config for CO calibrations

export const CO_FREQUENCIES = [
  "125HZ",
  "250Hz",
  "500Hz",
  "750Hz",
  "1Khz",
  "1.5Khz",
  "2Khz",
  "3Khz",
  "4Khz",
  "6KHZ",
  "8KHZ",
];

// ─────────────────────────────────────────────────────────────────────────────
// Référence sonomètre — utilisée pour le calcul automatique de la correction
// à partir d'une mesure sonomètre dans le modal "Ajouter une calibration CO".
//
//   correction = (niveauEntree + retvfCorrigeCF) − mesureSonometre − OFFSET
//
// Ces valeurs peuvent être ajustées librement ici sans toucher au backend
// (le serveur reçoit uniquement la chaîne finale calib_tonal = corrections
//  séparées par des virgules).
// ─────────────────────────────────────────────────────────────────────────────

// RETVF Corrigé du CF, dans l'ordre des CO_FREQUENCIES (125Hz → 8kHz)
export const CO_RETVF_CORRIGE_CF = [
  82, 66.5, 57.5, 48.3, 42.5, 37.5, 33, 32, 33, 32, 32,
];

// Niveau d'entrée appliqué pendant la mesure (dB), même ordre
export const CO_NIVEAU_ENTREE = [
  95, 95, 95, 95, 95, 95, 95, 95, 95, 75, 75,
];

// Constante retranchée dans la formule
export const CO_OFFSET = 20;

/**
 * Calcule la correction à enregistrer à partir d'une mesure sonomètre.
 * @param {number|string} mesureSonometre
 * @param {number} freqIdx index dans CO_FREQUENCIES
 * @returns {string} valeur de correction (1 décimale max), ou "" si entrée invalide
 */
export function computeCoCorrection(mesureSonometre, freqIdx) {
  const m = parseFloat(mesureSonometre);
  if (Number.isNaN(m)) return "";
  const niveau = CO_NIVEAU_ENTREE[freqIdx];
  const retvf = CO_RETVF_CORRIGE_CF[freqIdx];
  if (niveau === undefined || retvf === undefined) return "";
  const correction = (niveau + retvf) - m - CO_OFFSET;
  const rounded = Math.round(correction * 10) / 10;
  return Number.isInteger(rounded) ? String(rounded) : String(rounded);
}

// ─────────────────────────────────────────────────────────────────────────────
// Vocal — niveau d'entrée 75 dB, RETVF corrigé du CF 55
// Formule : (niveauEntree + RETVF) − mesure − CO_OFFSET − CO_VOCAL_EXTRA_OFFSET
// ─────────────────────────────────────────────────────────────────────────────
export const CO_VOCAL_NIVEAU_ENTREE = 75;
export const CO_VOCAL_RETVF = 55;
export const CO_VOCAL_EXTRA_OFFSET = 20;

/**
 * Calcule la correction vocale à enregistrer à partir d'une mesure sonomètre.
 * @param {number|string} mesureSonometre
 * @param {number} retvfVocal valeur RETVF corrigé CF pour cette ligne vocale
 * @returns {string}
 */
export function computeVocalCoCorrection(mesureSonometre, retvfVocal) {
  const m = parseFloat(mesureSonometre);
  if (Number.isNaN(m)) return "";
  const correction = (CO_VOCAL_NIVEAU_ENTREE + retvfVocal) - m - CO_OFFSET - CO_VOCAL_EXTRA_OFFSET;
  const rounded = Math.round(correction * 10) / 10;
  return Number.isInteger(rounded) ? String(rounded) : String(rounded);
}
